import React from 'react';
import { ErrorBoundary, Result } from './PageErrBoundary';
window.__component_load_state__ = {};
let isToggleLoading = false;
function loadComponent(bundle) {
    return async () => {
        // Initializes the share scope. This fills it with known provided modules from this build and all remotes
        // eslint-disable-next-line no-undef
        const now = Date.now();
        await __webpack_init_sharing__('default');
        const scopes = Object.keys(window.__federation_expose__);
        let scope;
        for (let index = 0; index < scopes.length; index++) {
            if (window.__federation_expose__[scopes[index]].indexOf(bundle) > -1) {
                scope = scopes[index];
                break;
            }
        }
        const container = window[scope]; // or get the container somewhere else
        if (!container) {
            return {
                default: () => (<Result status="404" title={`bundle '${bundle}' not found`}/>),
            };
        }
        // Initialize the container, it may provide shared modules
        // eslint-disable-next-line no-undef
        await container.init(__webpack_share_scopes__.default);
        const factory = await window[scope].get(bundle);
        const Module = factory();
        // 统计耗时
        if (!window.__component_load_state__[bundle]) {
            window.__component_load_state__[bundle] = {
                cost: Date.now() - now,
                timestamp: Date.now(),
                path: window.location.pathname,
            };
        }
        // 切换 loading
        if (window.location.pathname !== '/' && !isToggleLoading) {
            isToggleLoading = true;
            window.main_phx_load_done && window.main_phx_load_done();
        }
        return Module;
    };
}
function SubPage(props, Loading = null) {
    const Component = React.lazy(loadComponent(props.bundle));
    return (<React.Suspense fallback={() => <Loading /> || null}>
      <Component {...props}/>
    </React.Suspense>);
}
export default (bundle, loadingComponent = null) => (props) => (<ErrorBoundary>
        <SubPage {...props} bundle={bundle} loading={loadingComponent}/>
      </ErrorBoundary>);
